import { AspectRatio } from '@mui/icons-material'
import { Box, Typography, Icon, Grid, useMediaQuery } from '@mui/material'

const AdxActionButton = ({
  children,
  icon,
  icon2,
  iconColor,
  iconBgColor,
  title,
  description,
  onClick = () => null,
  actionMessage,
  sx,
  sxIcon,
  sxIcon2,
  divClick,
  ...rest
}) => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  const CardStyle = () => {
    return {
      bgcolor: 'white.main',
      p: 2,
      display: 'flex',
      justifyContent: 'space-between',
      gap: 2,
      alignItems: 'center',
      minHeight: 80,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'primary.light',
      },
    }
  }

  const IconStyle = () => {
    return {
      display: 'flex',
      minWidth: 45,
      minHeight: 45,
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      bgcolor: iconBgColor,
      color: iconColor,
    }
  }

  return (
    <Box onClick={divClick && (() => onClick())} sx={{ ...CardStyle(), ...sx }} {...rest}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon ? (
          <Box sx={{ ...IconStyle() }}>
            <Icon sx={{ fontSize: 25, ...sxIcon }}>{icon}</Icon>
          </Box>
        ) : null}
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
          <Typography noWrap variant="h4" fontWeight="700">
            {title}
          </Typography>
          <Grid container>
            <Grid item>
              <Typography variant="body1" color="light-gray-text.main">
                {description}
              </Typography>
            </Grid>
            <Grid item>{children}</Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        onClick={divClick ? null : () => onClick()}
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          color: 'alternate.main',
          gap: 1,
        }}
      >
        {isLarge && (
          <Typography variant="body1" sx={{ textDecoration: 'none' }}>
            {actionMessage}
          </Typography>
        )}

        <Icon sx={{ ...sxIcon2 }}>{icon2}</Icon>
      </Box>
    </Box>
  )
}

export default AdxActionButton
